const $569d0cfc45f5a9af$var$API_API_STORE = "unified-mapping-dev-menu-api-url";
const $569d0cfc45f5a9af$var$API_INDEX_STORE = "unified-mapping-dev-menu-api-index";
const $569d0cfc45f5a9af$var$MENU_TOGGLE_STORE = "unified-mapping-dev-menu-api-toggle";
const $569d0cfc45f5a9af$var$MENU_SELECTOR = ".unified-mapping-dev-menu.menu";
const $569d0cfc45f5a9af$var$EXPAND_SELECTOR = ".unified-mapping-dev-menu.expand";
const $569d0cfc45f5a9af$export$9450079900d3b9a1 = ()=>window.localStorage.getItem($569d0cfc45f5a9af$var$API_API_STORE) || "prod";
const $569d0cfc45f5a9af$export$a5a583fd7725c0af = ()=>window.localStorage.getItem($569d0cfc45f5a9af$var$API_INDEX_STORE) || "seniors";
const $569d0cfc45f5a9af$var$getMenuToggleStore = ()=>window.localStorage.getItem($569d0cfc45f5a9af$var$MENU_TOGGLE_STORE);
const $569d0cfc45f5a9af$var$setMenuToggleStore = (v)=>window.localStorage.setItem($569d0cfc45f5a9af$var$MENU_TOGGLE_STORE, v);
const $569d0cfc45f5a9af$var$setHighlightCombined = ()=>$569d0cfc45f5a9af$export$a5a583fd7725c0af() === "combined-dev" && window.localStorage.setItem($569d0cfc45f5a9af$var$API_API_STORE, "dev") || $569d0cfc45f5a9af$export$a5a583fd7725c0af() === "combined-stg" && window.localStorage.setItem($569d0cfc45f5a9af$var$API_API_STORE, "stg");
const $569d0cfc45f5a9af$var$checkMenuValue = (v)=>$569d0cfc45f5a9af$export$9450079900d3b9a1() === v || $569d0cfc45f5a9af$export$a5a583fd7725c0af() === v;
const $569d0cfc45f5a9af$var$createMenuButton = (i, v, text)=>{
    const el = document.createElement("button");
    el.innerText = text;
    el.style.border = $569d0cfc45f5a9af$var$checkMenuValue(v) ? "2px solid #4285F4" : "2px solid grey";
    el.onclick = ()=>(window.localStorage.setItem(i, v), window.location.reload());
    return el;
};
const $569d0cfc45f5a9af$var$setupDevMenu = ()=>{
    document.querySelector("html").classList.remove("hidden");
    $569d0cfc45f5a9af$var$setHighlightCombined();
    const menu = document.querySelector($569d0cfc45f5a9af$var$MENU_SELECTOR);
    const expand = document.querySelector($569d0cfc45f5a9af$var$EXPAND_SELECTOR);
    menu.style.display = "flex";
    menu.innerText = "Dev Menu";
    menu.style.transform = $569d0cfc45f5a9af$var$getMenuToggleStore() === "open" ? "translate(0, 0)" : "translate(-100%, 0)";
    expand.onclick = ()=>(menu.style.transform = "translate(0, 0)", $569d0cfc45f5a9af$var$setMenuToggleStore("open"));
    expand.style.display = "block";
    const closeButton = document.createElement("button");
    closeButton.innerText = "X";
    closeButton.onclick = ()=>($569d0cfc45f5a9af$var$setMenuToggleStore("close"), menu.style.transform = "translate(-100%, 0)");
    const prodButton = $569d0cfc45f5a9af$var$createMenuButton($569d0cfc45f5a9af$var$API_API_STORE, "prod", "prod api");
    const stgButton = $569d0cfc45f5a9af$var$createMenuButton($569d0cfc45f5a9af$var$API_API_STORE, "stg", "stg api");
    const devButton = $569d0cfc45f5a9af$var$createMenuButton($569d0cfc45f5a9af$var$API_API_STORE, "dev", "dev api");
    const seniorsCardButton = $569d0cfc45f5a9af$var$createMenuButton($569d0cfc45f5a9af$var$API_INDEX_STORE, "seniors", "seniors index");
    const seniorsButton = $569d0cfc45f5a9af$var$createMenuButton($569d0cfc45f5a9af$var$API_INDEX_STORE, "seniorscard", "seniorscard index");
    const activeKidsButton = $569d0cfc45f5a9af$var$createMenuButton($569d0cfc45f5a9af$var$API_INDEX_STORE, "activekids", "activekids index");
    const combDevButton = $569d0cfc45f5a9af$var$createMenuButton($569d0cfc45f5a9af$var$API_INDEX_STORE, "combined-dev", "dev combine seniors");
    const combStgButton = $569d0cfc45f5a9af$var$createMenuButton($569d0cfc45f5a9af$var$API_INDEX_STORE, "combined-stg", "stg combine seniors");
    menu.append(closeButton);
    closeButton.style.marginBottom = "2em";
    menu.append(prodButton);
    menu.append(stgButton);
    menu.append(devButton);
    devButton.style.marginBottom = "2em";
    menu.append(seniorsCardButton);
    menu.append(seniorsButton);
    menu.append(activeKidsButton);
    activeKidsButton.style.marginBottom = "1em";
    menu.append(combDevButton);
    menu.append(combStgButton);
    document.body.append(menu);
    return true;
};
const $569d0cfc45f5a9af$var$envIsDev = window.location.hostname === "dev.maps-dev.testservicensw.net" || window.location.hostname === "localhost";
const $569d0cfc45f5a9af$export$a97fd189d674ba9c = ()=>$569d0cfc45f5a9af$var$envIsDev && $569d0cfc45f5a9af$var$setupDevMenu() || false;


var $820877bea407f5fe$exports = {};
const $820877bea407f5fe$var$asLowerCase = (a)=>a.toLowerCase();
const $820877bea407f5fe$var$isActive = (d)=>$820877bea407f5fe$var$asLowerCase(d?.status) === "active";
const $820877bea407f5fe$var$asArray = (v)=>Array.from(v);
// eslint-disable-next-line import/prefer-default-export
const $820877bea407f5fe$var$filterActive = (d)=>d.reduce((a, c)=>$820877bea407f5fe$var$isActive(c) ? [
            ...a,
            c
        ] : a, []);
const $820877bea407f5fe$var$firstUpperCase = (s)=>s.toLowerCase().replace(/\b[a-z](?=[a-z]{2})/g, (letter)=>letter.toUpperCase());
const $820877bea407f5fe$var$capitaliseFirstLetter = (arr)=>arr.map((v)=>$820877bea407f5fe$var$firstUpperCase(v));
const $820877bea407f5fe$var$isContainerViewPort = (c)=>c.classList.contains("map-viewport-container");
const $820877bea407f5fe$var$sliceTags = (t)=>t.slice(0, 2).join(", ");
const $820877bea407f5fe$var$addContent = (t)=>`... +${t.length - 2} more`;
const $820877bea407f5fe$var$maybeAddContent = (t)=>t.length === 2 ? [
        $820877bea407f5fe$var$sliceTags(t)
    ] : [
        `${$820877bea407f5fe$var$sliceTags(t)} ${$820877bea407f5fe$var$addContent(t)}`
    ];
const $820877bea407f5fe$var$maybeSliceTags = (t, c)=>t.length >= 2 && $820877bea407f5fe$var$isContainerViewPort(c) ? $820877bea407f5fe$var$maybeAddContent(t) : t;
const $820877bea407f5fe$var$addPill = (el)=>el.classList.add("tag-pill");
const $820877bea407f5fe$var$maybeAddPill = (el, c)=>!$820877bea407f5fe$var$isContainerViewPort(c) ? $820877bea407f5fe$var$addPill(el) : el;
const $820877bea407f5fe$var$setContent = (el, c)=>el.textContent = c;
const $820877bea407f5fe$var$appendTags = (mapItemProp, tag, container)=>{
    const tagElement = document.createElement("div");
    $820877bea407f5fe$var$setContent(tagElement, tag);
    $820877bea407f5fe$var$maybeAddPill(tagElement, container);
    return mapItemProp.appendChild(tagElement);
};
const $820877bea407f5fe$var$setTags = (container)=>(v)=>{
        const tags = v.textContent.split(",").map((tag)=>tag.trim());
        $820877bea407f5fe$var$setContent(v);
        $820877bea407f5fe$var$maybeSliceTags(tags, container).map((tag)=>$820877bea407f5fe$var$appendTags(v, tag, container));
    };
const $820877bea407f5fe$var$selectTags = (v)=>v.querySelectorAll('map-item-prop[name="tags"]');
const $820877bea407f5fe$var$isAddedNodeMapItem = (node)=>// eslint-disable-next-line no-undef
    node instanceof Element && node.nodeName.toLowerCase() === "map-item";
const $820877bea407f5fe$var$visualiseTags = (container)=>{
    const observer = new MutationObserver((mutations)=>{
        mutations.forEach((mutation)=>{
            const addedNodes = Array.from(mutation.addedNodes);
            const mapItemProps = addedNodes.filter($820877bea407f5fe$var$isAddedNodeMapItem).flatMap((mapItem)=>$820877bea407f5fe$var$asArray($820877bea407f5fe$var$selectTags(mapItem)));
            mapItemProps.forEach($820877bea407f5fe$var$setTags(container));
        });
    });
    return observer.observe(container, {
        childList: true,
        subtree: true
    });
};
$820877bea407f5fe$exports = {
    filterActive: $820877bea407f5fe$var$filterActive,
    capitaliseFirstLetter: $820877bea407f5fe$var$capitaliseFirstLetter,
    visualiseTags: $820877bea407f5fe$var$visualiseTags
};


const $07e432405c06eb4a$var$start = ()=>{
    const storeIndex = (0, $569d0cfc45f5a9af$export$a5a583fd7725c0af)();
    const storeAPI = (0, $569d0cfc45f5a9af$export$9450079900d3b9a1)();
    const prodAPI = (i = storeIndex)=>`https://api.maps.service.nsw.gov.au/search/${i}?name=&category=&subcategory=&neLat=10.0&neLon=175.5&swLat=-57.2&swLon=89.7`;
    const stgAPI = (i = storeIndex)=>`https://api.maps-stg.testservicensw.net/cache/${i}`;
    const devAPI = (i = storeIndex)=>`https://dev-api.maps-dev.testservicensw.net/cache/${i}`;
    const viewport = document.querySelector("map-viewport");
    const fromLatLon = ({ lat: lat , lon: lon  })=>({
            lat: lat,
            lng: lon
        });
    const transformData = (d)=>{
        console.log(d);
        return d.map(({ location: location , name: name , category: category , industryType: industryType , ...rest })=>({
                ...fromLatLon(location),
                name: name.trim(),
                tags: industryType ? (0, $820877bea407f5fe$exports.capitaliseFirstLetter)(industryType) : [
                    category
                ],
                ...rest
            }));
    };
    const fetchData = (url)=>fetch(url).then((res)=>res.json());
    const fetchDevCombinedData = ()=>fetchData(devAPI("seniors")).then((d1)=>fetchData(devAPI("seniorscard")).then((d2)=>[
                    ...d1,
                    ...d2
                ]));
    const fetchStgCombinedData = ()=>fetchData(stgAPI("seniors")).then((d1)=>fetchData(stgAPI("seniorscard")).then((d2)=>[
                    ...d1,
                    ...d2
                ]));
    const maybeFetchIndex = (url)=>storeIndex === "combined-dev" && fetchDevCombinedData() || storeIndex === "combined-stg" && fetchStgCombinedData() || fetchData(url);
    const setData = (d)=>(console.dir(viewport), viewport.load(transformData(d)));
    const maybeProdData = ()=>{
        switch(storeAPI){
            case "prod":
                return maybeFetchIndex(prodAPI());
            case "stg":
                return maybeFetchIndex(stgAPI());
            default:
                return maybeFetchIndex(devAPI());
        }
    };
    const maybeRows = (d)=>d?.rows || d;
    const loadData = ()=>maybeProdData() //
        .then(maybeRows).then((0, $820877bea407f5fe$exports.filterActive)).then(setData);
    viewport.init("google", "AIzaSyAbvtFai2_G3xh6p1NCFpOfxdqUstrXQzc").then(loadData);
    let footerExpanded = false;
    const footerButton = document.getElementById("FooterButton");
    const list = document.querySelector(".map-list-container");
    const footer = document.getElementById("FooterContainer");
    const viewportContainer = document.querySelector(".map-viewport-container");
    const recordCount = document.querySelector(".record-counts");
    footerButton.addEventListener("click", ()=>{
        footerExpanded = !footerExpanded;
        footer.style.bottom = footerExpanded ? 0 : "";
        footer.style.overflow = footerExpanded ? "scroll" : "hidden";
    });
    list.addEventListener("click", ()=>{
        setTimeout(()=>{
            const closeButton = document.querySelector('map-selection button[close-button="true"]');
            const mapSelection = document.querySelector("map-selection");
            list.classList.add("mobile-hidden-by-selection");
            recordCount.classList.add("mobile-hidden-by-selection");
            mapSelection.scrollTop = 0;
            closeButton.addEventListener("click", ()=>{
                list.classList.remove("mobile-hidden-by-selection");
                recordCount.classList.remove("mobile-hidden-by-selection");
            });
        });
    });
    const selection = document.querySelector("map-selection");
    // Click phone number link
    selection.addEventListener("click-phone", ({ detail: detail  })=>window.open(`tel:${detail.phone}`, "_self"));
    // Click webiste link
    selection.addEventListener("click-link", ({ detail: detail  })=>{
        window.open(detail.web, "_blank");
    });
    // Click get directions
    selection.addEventListener("click-directions", ({ detail: detail  })=>{
        window.open(`https://www.google.com/maps/dir/?api=1&destination=${detail.address}&travelmode=driving`);
    });
    // Click get directions
    viewport.addEventListener("click-directions", ({ detail: detail  })=>{
        window.open(`https://www.google.com/maps/dir/?api=1&destination=${detail.address}&travelmode=driving`);
    });
    const mapViewButton = document.getElementById("map-view-tab-button");
    const listViewButton = document.getElementById("list-view-tab-button");
    // Switch to map view
    mapViewButton.addEventListener("click", ()=>{
        viewportContainer.classList.remove("mobile-hidden-by-view");
        list.classList.add("mobile-hidden-by-view");
        mapViewButton.style.borderBottom = "2px solid red";
        listViewButton.style.borderBottom = "medium none";
    });
    // Switch to list view
    listViewButton.addEventListener("click", ()=>{
        viewportContainer.classList.add("mobile-hidden-by-view");
        list.classList.remove("mobile-hidden-by-view");
        mapViewButton.style.borderBottom = "medium none";
        listViewButton.style.borderBottom = "2px solid red";
    });
};
const $07e432405c06eb4a$var$maybeStart = ()=>(0, $569d0cfc45f5a9af$export$a97fd189d674ba9c)() ? $07e432405c06eb4a$var$start() : document.querySelector("html").remove();
$07e432405c06eb4a$var$maybeStart();


//# sourceMappingURL=index.ded43035.js.map
